import Vue from "vue";
import VueRouter from "vue-router";
import layout from "../views/layout/layout"; // 侧边栏
import cassificationDetails from "../views/cassificationDetails"; // 分类详情页面
import courseInformation from "../views/courseInformation"; // 课程信息首页
import classManagement from "../views/classManagement"; // 班级管理首页
import resourceManagement from "../views/resourceManagement"; // 资源管理首页
import addResources from "../views/resourceManagement/addResources"; // 资源管理=>添加资源
import webLink from "../views/resourceManagement/webLink"; // 资源管理=>网页链接
import addExercises from "../views/resourceManagement/addExercises"; // 资源管理=>添加习题
import addTestPaper from "../views/resourceManagement/addTestPaper"; // 资源管理=>添加作业
import addFromProblemLibrary from "../views/resourceManagement/addFromProblemLibrary"; // 资源管理=>从资源库添加
import courseTeaching from "../views/courseTeaching"; // 课程教学首页
import dataStatistics from "../views/courseTeaching/dataStatistics"; // 课程教学=>数据统计
import exerciseReview from "../views/courseTeaching/exerciseReview"; // 课程教学=>习题批阅
import resourceData from "../views/courseTeaching/resourceData"; // 课程教学=>资源数据
import testPaperData from "../views/courseTeaching/testPaperData/index.vue"; // 课程教学=>作业查看数据
import textbookEditor from "../views/textbookEditor/index.vue"; // 教材编辑首页
import AREditing from "../views/AREditing/index.vue"; // 教材编辑首页
import studentStatistics from "../views/studentStatistics"; // 学情统计首页
import viewPoints from "../views/viewPoints"; // 积分查看首页
import pointsDetails from "../views/viewPoints/pointsDetails"; // 积分查看=>积分详情
import onlineExamination from "../views/onlineExamination/index/index.vue"; // 线上考试首页
import manualTestComposition from "../views/onlineExamination/manualTestComposition/index.vue"; // 线上考试=>手动组卷
import automaticTestComposition from "../views/onlineExamination/automaticTestComposition/index.vue"; // 线上考试=>自动组卷
import aiAssistant from "../views/AI/aiAssistant.vue"; // AI助手首页

// import components from "vue/types/umd";
Vue.use(VueRouter);
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/guidePage",
    name: "guidePage",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/guidePage.vue"), // 医药云课堂先导页面
  },
  {
    path: "/createNewCategory",
    name: "createNewCategory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/createNewCategory.vue"), // 医药云课堂开发者新建分类页面
  },
  {
    path: "/messageList",
    name: "messageList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/messageList.vue"), // 医药云课堂开发者消息列表
  },
  {
    path: "/register",
    name: "register",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/register.vue"), // 医药云课堂登录页
  },
  {
    path: "/register1",
    name: "register1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/register1.vue"), // 云课堂登录页
  },
  // 首页
  {
    path: "/homepage",
    name: "homepage",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/homepage.vue"),
  },
  // 新建课程
  {
    path: "/newCourse",
    name: "newCourse",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/newCourse.vue"),
  },
  // 新建教材
  {
    path: "/newTextbook",
    name: "newTextbook",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/newTextbook.vue"),
  },
  // 个人信息
  {
    path: "/personalInformation",
    name: "personalInformation",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/personalInformation.vue"),
  },
  // 分类详情页面
  {
    path: "/cassificationDetails",
    name: "cassificationDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: cassificationDetails,
  },
  // 开始上课
  {
    path: "/courseTeaching/classesBegin",
    name: "classesBegin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/courseTeaching/classesBegin.vue"),
  },
  // AI助手
  {
    path: "/aiAssistant",
    name: "aiAssistant",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AI/aiAssistant.vue"),
  },
  // 侧边栏
  {
    path: "/layout",
    name: "layout",
    redirect: "/courseInformation",
    component: layout,
    children: [
      // 课程信息首页
      {
        path: "/courseInformation",
        name: "courseInformation",
        component: courseInformation,
      },
      // 班级管理首页
      {
        path: "/classManagement",
        name: "classManagement",
        component: classManagement,
      },
      // 资源管理首页
      {
        path: "/resourceManagement",
        name: "resourceManagement",
        component: resourceManagement,
      },
      // 资源管理=>添加资源
      {
        path: "/addResources",
        name: "addResources",
        component: addResources,
      },
      // 资源管理=>网页链接
      {
        path: "/webLink",
        name: "webLink",
        component: webLink,
      },
      // 资源管理=>添加习题
      {
        path: "/addExercises",
        name: "addExercises",
        component: addExercises,
      },
      // 资源管理=>添加作业
      {
        path: "/addTestPaper",
        name: "addTestPaper",
        component: addTestPaper,
        // meta: {
        //   keepAlive: true, // 需要被缓存
        // },
      },
      // 资源管理=>从资源库添加
      {
        path: "/addFromProblemLibrary",
        name: "addFromProblemLibrary",
        component: addFromProblemLibrary,
      },
      // 线上考试首页
      {
        path: "/onlineExamination",
        name: "onlineExamination",
        component: onlineExamination,
      },
      // 线上考试=>手动组卷
      {
        path: "/manualTestComposition",
        name: "manualTestComposition",
        component: manualTestComposition,
      },
      // 线上考试=>自动组卷
      {
        path: "/automaticTestComposition",
        name: "automaticTestComposition",
        component: automaticTestComposition,
      },
      // 教材编辑首页
      {
        path: "/textbookEditor",
        name: "textbookEditor",
        component: textbookEditor,
      },
      // AR编辑首页
      {
        path: "/AREditing",
        name: "AREditing",
        component: AREditing,
      },
      // 课程教学首页
      {
        path: "/courseTeaching",
        name: "courseTeaching",
        component: courseTeaching,
      },
      // 课程教学=>习题批阅
      {
        path: "/exerciseReview",
        name: "exerciseReview",
        component: exerciseReview,
      },
      // 课程教学=>习题统计
      {
        path: "/dataStatistics",
        name: "dataStatistics",
        component: dataStatistics,
      },
      // 课程教学=>资源数据
      {
        path: "/resourceData",
        name: "resourceData",
        component: resourceData,
      },
      // 课程教学=>作业查看数据
      {
        path: "/testPaperData",
        name: "testPaperData",
        component: testPaperData,
      },
      // 学情统计首页
      {
        path: "/studentStatistics",
        name: "studentStatistics",
        component: studentStatistics,
      },
      // 积分查看首页
      {
        path: "/viewPoints",
        name: "viewPoints",
        component: viewPoints,
      },
      // 积分查看=>积分详情
      {
        path: "/pointsDetails",
        name: "pointsDetails",
        component: pointsDetails,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
